import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { PaginatedResult } from '../models/paginated-result';
import { API_SALESDOC_SERVER_URL } from '../../config';
import { FieldOfHelpDocument, HelpDocument, HelpDocumentFile } from '../models/help-document';
import { OrderBy } from '../utils/constant';

import { ConnectionService } from './connection.service';

const GET_HELP_DOCUMENT_URL = `${ API_SALESDOC_SERVER_URL }/v2/helpDocuments`;
@Injectable({ providedIn: 'root' })
export class HelpDocumentService {
	constructor(
		private readonly http: HttpClient,
		private readonly connectionService: ConnectionService
	) {}

	getHelpDocument(
		fields: readonly FieldOfHelpDocument[],
		filter: string | undefined,
		index: number,
		limit: number,
		orderBy: OrderBy<keyof HelpDocument>[] | OrderBy<keyof HelpDocument>,
		onlyDistinct: boolean
	) {
		const url = new URL(GET_HELP_DOCUMENT_URL);
		const params = url.searchParams;
		params.append('fields', fields.join(','));
		if (filter) {
			params.append('filter', filter);
		}
		params.append('page', String(Math.floor(index / limit) + 1));
		params.append('limit', String(limit));

		params.append('orderBy', Array.isArray(orderBy) ? orderBy.join(',') : String(orderBy));

		params.append('distinct', String(onlyDistinct));

		return this.http.get<PaginatedResult<HelpDocument>>(url.toString());
	}

	getURL(file: HelpDocumentFile, id: number) {
		const url = new URL(`${ GET_HELP_DOCUMENT_URL }/${
			id
		}/attachments/${ file.id }/${ file.fileName }`);
		const params = url.searchParams;
		params.append('access_token', this.connectionService.getDownloadAccessToken());
		return url.toString();
	}
}
